import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { SharedMessagesPropType } from '../../../../prop-types/intl';

const messages = defineMessages({
  title: {
    description: 'cancelledPlaceholder.title',
    defaultMessage: 'You have no <b>Cancelled</b> orders',
    id: 'MqLK3g',
  },
  titleWithStore: {
    description: 'cancelledPlaceholder.titleWithStore',
    defaultMessage: 'You have no <b>Cancelled</b> orders from {storeName}',
    id: '2Cbqqk',
  },
  description: {
    description: 'cancelledPlaceholder.description',
    defaultMessage:
      "Sometimes things don't work out: a shopper cancels an order or you can't ship the order. Those orders will show up here once cancelled.",
    id: 'bsJXro',
  },
});

const title = (storeName) =>
  storeName ? (
    <FormattedMessage {...messages.titleWithStore} values={{ b: (chunks) => <b>{chunks}</b>, storeName }} />
  ) : (
    <FormattedMessage {...messages.title} values={{ b: (chunks) => <b>{chunks}</b> }} />
  );

const CancelledPlaceholder = ({ action, sharedMessages, hasStoreConnected, storeName }) => {
  return (
    <ActionablePlaceholder
      action={action}
      actionDescription={!hasStoreConnected && <FormattedMessage {...sharedMessages.actionDescription} />}
      buttonContent={!hasStoreConnected && <FormattedMessage {...sharedMessages.buttonContent} />}
      description={<FormattedMessage {...messages.description} />}
      title={title(storeName)}
    />
  );
};

CancelledPlaceholder.propTypes = {
  action: PropTypes.func.isRequired,
  sharedMessages: SharedMessagesPropType.isRequired,
  hasStoreConnected: PropTypes.bool.isRequired,
  storeName: PropTypes.string,
};

export default CancelledPlaceholder;
